import * as Service from '../../services/config';

export default {
  /**
   * Get All countries
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllAvailableDay({ commit }) {
    const response = await Service.fetchAllAvailable();
    commit('setProperty', { property: 'days', payload: response });
  },

  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchMerchantProfile({ commit }) {
    const response = await Service.fetchMerchantProfile();
    commit('setProperty', { property: 'profile', payload: response });
  },

  /**
   *
   * @param commit
   * @param rootState
   * @param state
   * @returns {Promise<void>}
   */
  async saveMerchantProfile({ rootState, state }) {
    await Service.saveMerchantProfile(rootState.AuthStore.user.merchant[0].id, state.profile.profile);
  },

  /**
   *
   * @param rootState
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchMerchantConfig({ rootState, commit }) {
    const config = await Service.fetchMerchantConfig();
    commit('setProperty', { property: 'config', payload: config.length > 0 ? config[0] : {} });

    const options = await Service.fetchMerchantDeliveryOptions(rootState.AuthStore.user.merchant[0].id);
    const ids = options.map(item => item.id);

    commit('setProperty', { property: 'merchant_delivery_options', payload: ids });

    const paymentMethod = await Service.fetchPaymentMethod();
    commit('setProperty', { property: 'payment_method', payload: paymentMethod });

    const deliveryMethod = await Service.fetchDeliveryMethod();
    commit('setProperty', { property: 'delivery_method', payload: deliveryMethod });

    const deliveryOption = await Service.fetchDeliveryOption();
    commit('setProperty', { property: 'delivery_option', payload: deliveryOption });

    const socialAuth = await Service.fetchSocialAuth();
    commit('setProperty', { property: 'social_auth', payload: socialAuth });

    const homeDeliveryOption = await Service.getHomeDeliveryOptions();
    commit('setProperty', { property: 'home_delivery_options', payload: homeDeliveryOption });
  },

  /**
   *
   * @param state
   * @returns {Promise<void>}
   */
  async saveMerchantConfig({ state }) {
    await Service.saveMerchantConfig(state.config.id, state.config);
  },

  /**
   *
   * @param rootState
   * @param state
   * @returns {Promise<void>}
   */
  async saveMerchantDeliveryOptions({ rootState, state }) {
    await Service.attachDeliveryOptions(rootState.AuthStore.user.merchant[0].id, state.merchant_delivery_options);
  },

  /**
   *
   * @param context
   * @param type
   * @param data
   * @returns {Promise<void>}
   */
  async uploadMerchantImages({ rootState }, { type, data }) {
    await Service.uploadMerchantImages(type, data, rootState.AuthStore.user.merchant[0].id);
  },

  /**
   *
   * @param context
   * @param id
   * @returns {Promise<*>}
   */
  async deleteHeroImages(context, { id }) {
    return Service.deleteMerchantImages(id);
  },
};
